import React from 'react';
import { Link } from 'react-router-dom';

export default function AuthShell({ eyebrow, title, subtitle, children, compact = false }) {
  return (
    <div className="auth-page auth-experience">
      <header className="auth-topbar">
        <Link to="/" className="auth-brand" aria-label="TuWay Africa home">
          <img src="/app-icon.png" alt="" />
          <span>TuWay Africa</span>
        </Link>
        <Link to="/" className="auth-home-link">Explore TuWay <span aria-hidden="true">↗</span></Link>
      </header>

      <div className="auth-layout">
        <aside className="auth-story" aria-label="TuWay Africa product preview">
          <div className="auth-story-glow" />
          <div className="auth-story-copy">
            <span className="auth-story-kicker">Your customer command centre</span>
            <h2>Know what lands.<br />See what grows.</h2>
            <p>One calm workspace for conversations, campaigns and the numbers that move your business.</p>
          </div>

          <div className="auth-product-frame" aria-hidden="true">
            <div className="auth-product-sidebar">
              <span className="auth-product-mark">T</span>
              <span className="active" />
              <span />
              <span />
              <span />
              <span />
            </div>
            <div className="auth-product-main">
              <div className="auth-product-head">
                <div><small>GOOD MORNING</small><strong>Your business, at a glance.</strong></div>
                <i>New broadcast</i>
              </div>
              <div className="auth-product-stats">
                <div><small>CUSTOMERS</small><strong>2,481</strong><em>+12% this month</em></div>
                <div><small>DELIVERY RATE</small><strong>98.4%</strong><em>Healthy</em></div>
                <div><small>LINK CLICKS</small><strong>1,560</strong><em>+18% this month</em></div>
              </div>
              <div className="auth-product-grid">
                <div className="auth-product-chart">
                  <small>AUDIENCE GROWTH</small>
                  <svg viewBox="0 0 360 105" preserveAspectRatio="none">
                    <defs>
                      <linearGradient id="authChartFill" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0" stopColor="#35e08f" stopOpacity=".28" />
                        <stop offset="1" stopColor="#35e08f" stopOpacity="0" />
                      </linearGradient>
                    </defs>
                    <path d="M0 94 C38 80 58 90 91 65 S146 72 176 48 S232 56 264 30 S320 36 360 8 L360 105 L0 105 Z" fill="url(#authChartFill)" />
                    <path d="M0 94 C38 80 58 90 91 65 S146 72 176 48 S232 56 264 30 S320 36 360 8" fill="none" stroke="#35e08f" strokeWidth="3" />
                  </svg>
                </div>
                <div className="auth-product-activity">
                  <small>LATEST ACTIVITY</small>
                  <span><b>✓</b><i>Summer offer</i><em>2m</em></span>
                  <span><b>↗</b><i>New customer</i><em>8m</em></span>
                  <span><b>✓</b><i>Welcome flow</i><em>21m</em></span>
                </div>
              </div>
            </div>
          </div>

          <div className="auth-story-foot">
            <span>Built for growing African businesses</span>
            <span className="auth-story-dots"><i /><i /><i /></span>
          </div>
        </aside>

        <main className={`auth-panel${compact ? ' compact' : ''}`}>
          <div className="auth-card">
            {eyebrow && <div className="auth-eyebrow">{eyebrow}</div>}
            <div className="auth-heading">
              <h1>{title}</h1>
              {subtitle && <p>{subtitle}</p>}
            </div>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}

export function AuthDivider({ children }) {
  return <div className="auth-divider"><span>{children}</span></div>;
}
